import React from 'react'
import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink } from '@apollo/client'

// Wraps the entire Gatsby app with Apollo.
export const wrapRootElement = ({ element }) => {
  // Register a new Apollo client.
  const client = new ApolloClient({
    // Change this to your GraphQL endpoint.
    link: new HttpLink({ uri: 'https://data.circlekwestgolf.com/graphql' }),
    cache: new InMemoryCache(),
  })

  // Wrap the element.
  return <ApolloProvider client={client}>{element}</ApolloProvider>
}
